export const common = {
  actions: {
    actions: 'Actions',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    detail: 'Details',
    list: 'List',
    show: 'Show',
    update: 'Update',
    duplicate: 'Duplicate',
    download: 'Download',
    downloadTemplate: 'Download template',
    downloadErrorFile: 'Download error file',
    upload: 'Upload',
    print: 'Print',
    close: 'Close',
    open: 'Open',
    add: 'Add',
    remove: 'Remove',
    select: 'Select',
    clear: 'Clear',
    submit: 'Submit',
    reset: 'Reset',
    confirmDelete: 'Confirm delete',
    confirmAction: 'Confirm action',
    approve: 'Approve',
    reject: 'Reject',
    archive: 'Archive',
    unarchive: 'Unarchive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    stopActivity: 'Deactivate',
    allowActivity: 'Allow activity',
    enable: 'Enable',
    disable: 'Disable',
    lock: 'Lock',
    unlock: 'Unlock',
    importData: 'Import Data',
    exportData: 'Export Data',
    generateReport: 'Generate report',
    viewReport: 'View report',
    send: 'Send',
    receive: 'Receive',
    process: 'Process',
    validate: 'Validate',
    complete: 'Complete',
    cancelAction: 'Cancel action',
    create: 'Create',
    back: 'Back',
    skip: 'Skip',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    apply: 'Apply',
    search: 'Search',
    selectNone: 'None',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    stop: 'Stop',
    previewBeforeCreate: 'Preview before create',
    refresh: 'Refresh',
    imagePreview: 'Image preview',
    hideFilter: 'Hide filters',
    showFilter: 'Show filters',
    comingSoon: 'Feature in development',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    listActive: 'Active',
    listInactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
    draft: 'Draft',
  },
  messages: {
    success: 'Success',
    updateSuccess: 'Update successful',
    createSuccess: 'Creation successful',
    deleteSuccess: 'Deletion successful',
    error: 'An error occurred',
    warning: 'Warning',
    info: 'Information',
    loading: 'Loading...',
    noData: 'No data available',
    confirmDelete: 'Are you sure you want to delete this?',
    confirmDeleteCode: 'Item to delete: {code}',
    noImages: 'No images available',
    checkRequiredFields: 'Please check required fields',
    'image/*': 'Only image files are allowed',
    cantUploadImage: 'Cannot upload image',
    uploadImageError: 'Error uploading image',
    uploading: 'Uploading images...',
    pasteNoImage: 'Clipboard has no image. Copy an image or paste an http(s) link.',
    uploadSuccess: 'Images uploaded successfully',
    uploadMore: 'Upload more images',
    dragHere: 'Drag and drop images here',
    orClickHere: 'or click here to select',
    dragHereOrClick: 'Drag and drop images here or click to select',
  },
  validation: {
    required: 'This field is required',
    email: 'Invalid email format',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    numeric: 'Only numbers allowed',
  },
  date: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    thisQuarter: 'This quarter',
    lastQuarter: 'Last quarter',
    thisYear: 'This year',
    lastYear: 'Last year',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    pickDate: 'Pick date',
  },
  sortBy: 'Sort by',
  sortDirection: 'Sort direction',
  asc: 'Ascending',
  desc: 'Descending',
  table: {
    pageSize: 'Show:',
    perPage: 'page',
    showingRange: 'Showing {from} - {to} / Total {total}',
    showingRangeProducts: 'Showing {from} - {to} / Total {total} products',
    rowActions: 'Actions',
  },
  labels: {
    code: 'Code',
  },
  account: 'Account',
  profile: 'Profile',
  role: {
    super_admin: 'Super admin',
    admin: 'Admin',
    manager: 'Manager',
    standard_user: 'Standard user',
    customer: 'Customer',
  },
  total: 'Total',
  yes: 'Yes',
  no: 'No',
  stt: 'No.',
  noData: 'No data',
  getTax: 'Get tax',
  themeAccent: {
    aria: 'Choose theme color',
  },
  importModal: {
    fileSelected: 'Selected file: {name}',
  },
  importTemplate: {
    success: 'Template downloaded',
    failed: 'Failed to download template',
  },
  importResult: {
    errorColumnHeader: 'Error',
    downloadErrorFileFailed: 'Could not create error file',
  },
  import: {
    stubDescription:
      'Select an Excel file (.xlsx) using the template. Data is sent via a stub import API until the real backend endpoint is available.',
    stubSuccess: 'Import succeeded (stub API).',
    stubFailed: 'Import failed.',
    noData: 'No valid rows in the file.',
    noSheet: 'Excel file has no data sheet.',
    notSupportedByBackend: 'Excel import is not supported by the backend for this module yet.',
  },
  export: {
    exportFile: 'Export',
    exportExcelButton: 'Export Excel',
    exportOverview: 'Export overview',
    exportDetail: 'Export detail',
    exportSuccess: 'Excel file downloaded.',
    selectRowForDetail: 'Select a row in the table to export detail.',
    selectRowsFirst: 'Select at least one row to export.',
    exportSelectedVisible: 'Selected — visible columns ({count})',
    exportSelectedAllColumns: 'Selected — all columns ({count})',
    exportSelectedWithLinesVisible: 'Selected + lines — visible columns ({count})',
    exportSelectedWithLinesAll: 'Selected + lines — all columns ({count})',
    exportFilterVisible: 'By filter — visible columns',
    exportFilterAllColumns: 'By filter — all columns',
    exportFilterWithLinesVisible: 'By filter + lines — visible columns',
    exportFilterWithLinesAll: 'By filter + lines — all columns',
    lineCode: 'Item code',
    lineName: 'Item name',
    lineQty: 'Quantity',
    linePrice: 'Unit price',
    lineAmount: 'Amount',
    lineUnit: 'UoM',
    lineDiscount: 'Line discount',
    lineSellPrice: 'Sell price',
    lineSharedDiscount: 'Shared discount',
    lineOtherFee: 'Other fees',
    lineTotal: 'Total',
    lineWeight: 'Weight (kg)',
    lineVolume: 'Volume (m³)',
    lineNote: 'Note',
    customerCode: 'Customer code',
    customerName: 'Customer name',
    branch: 'Branch',
    seller: 'Seller',
    time: 'Time',
    status: 'Status',
    infoSheet: 'Voucher info',
    listSheet: 'Invoice list',
    linesSheet: 'Line items',
    infoField: 'Field',
    infoValue: 'Value',
  },
  /** Shared strings for the generic `ConfirmDialog` (BaseModal) — reusable by any module. */
  confirmDialog: {
    /** When codes.length > maxInlineCodes: "... and {count} more" */
    bulkAndMore: '... and {count} more',
  },
  /** Shared strings for POS Ban-hang tabs (right-click context menu + bulk close). */
  unsaved: {
    closeTitle: 'Close unsaved voucher?',
    closeBody: 'Your entries have not been saved. Closing will discard these changes.',
    discard: 'Close and discard',
  },
  tabs: {
    closeTab: 'Close tab',
    closeOthers: 'Close other tabs',
    closeRight: 'Close tabs to the right',
    bulkCloseTitle: 'Close multiple tabs?',
    bulkCloseBody:
      '{count} tabs have unsaved changes. Closing them will discard those changes.',
    closeAllDrafts: 'Close all drafts',
    closeAllDraftsTitle: 'Close all drafts?',
    closeAllDraftsBody:
      'All {count} open drafts will be removed and unsaved data will be lost. A new blank voucher will be opened.',
  },
  /** Shared branch filter labels for list sidebars. */
  filter: {
    chiNhanh: 'Branch',
    chiNhanhAll: 'All branches',
    chiNhanhSearch: 'Search branch',
    chiNhanhEmpty: 'No branches',
    chonTatCa: 'Select all',
    boChonTatCa: 'Deselect all',
  },
  /** Shared column show/hide menu (ProductListColumnMenu — all list modules). */
  columnPicker: {
    selectAll: 'Select all',
    deselect: 'Deselect',
    default: 'Default',
    sort: 'Reorder',
    sortDone: 'Done reordering',
    resetOrder: 'Reset order',
    sortHint: 'Select columns to move, then press ↑/↓ on another column to place above/below',
    fixedLeft: 'Pin left',
    fixedRight: 'Pin right',
    columnsTitle: 'Columns',
    sortColumnsTitle: 'Reorder columns',
    placeAbove: 'Place above',
    placeBelow: 'Place below',
    autoFit: 'Auto-fit column widths',
    viewMenu: 'View',
    defaultView: 'Default',
    defaultViewHint: 'Normal style, original column widths',
    autoFitShort: 'Fit columns',
    excelView: 'Excel',
    excelViewHint: 'Gridlines, compact cells',
    ultraView: 'Ultra compact',
    ultraViewHint: 'Gridlines, small text, tight cells — most rows on screen',
    resizeHandle: 'Drag to resize column, double-click to fit content',
    resetWidths: 'Reset',
    resetWidthsHint: 'Reset column widths (clear adjustments on this device)',
    gridLines: 'Grid',
    gridLinesHint: 'Toggle lines between columns',
    actionsColumn: 'Column {name}',
    decreaseFixed: 'Decrease pinned columns',
    increaseFixed: 'Increase pinned columns',
  },
  voucherPrint: {
    title: 'Print voucher',
    codeLabel: 'Voucher code',
    templateLabel: 'Print template',
    printButton: 'Print',
    exportExcelButton: 'Export Excel',
    editTemplateButton: 'Edit print template',
    loading: 'Loading print data…',
    loadingPreview: 'Loading preview…',
    loadError: 'Could not load print data',
    printError: 'Could not print voucher',
    missingId: 'Missing voucher id to print',
    batchCount: '{count} vouchers',
    batchModeOnce: 'Print once',
    batchModeOnceHint: 'One print dialog — each invoice starts on a new page',
    batchModeEach: 'One per invoice',
    batchModeEachHint: 'Open a separate print dialog for each invoice',
    noTemplate: 'No templates',
    noTemplateHint: 'No template for this voucher type — default template will be used when you print.',
    defaultBadge: 'Default',
    previewButton: 'Test print',
    previewTitle: 'Test print',
    previewDraftBadge: 'Draft — not saved',
    previewEmpty: 'Nothing to test print yet',
    pdfGroup: 'PDF templates',
    excelGroup: 'Excel templates',
    builtInTemplate: 'Built-in template',
    printSelected: 'Print ({count})',
    exportSelected: 'Export Excel ({count})',
    selectAll: 'Select all',
    previewPane: 'Preview',
    templatesPane: 'Templates',
    paperSize: '{w} × {h} mm',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    zoomReset: '100%',
  },
  voucherQr: {
    column: 'QR',
    view: 'View QR',
    title: 'Voucher QR code',
    copyCode: 'Copy code',
    copied: 'Voucher code copied',
    copyError: 'Could not copy',
    download: 'Download QR',
    linkedCodes: 'Linked codes',
  },
  disabledReason: {
    processing: 'Processing, please wait…',
    noCode: 'This voucher has no code yet, so no QR can be generated',
    notSaved: 'This voucher has not been saved yet',
    printUnavailable: 'No print template is configured for this voucher type',
  },
  filePreview: {
    title: 'File preview',
    kindPdf: 'PDF',
    kindExcel: 'Excel',
    kindImage: 'Image',
    kindOther: 'File',
    prev: 'Previous',
    next: 'Next',
    prevFile: 'Previous file',
    nextFile: 'Next file',
    openOriginal: 'Open original',
    openFile: 'Open file',
    missingUrl: 'Missing file URL to preview.',
    excelNoSheet: 'This Excel file has no data sheet.',
    excelRowLimit: 'Showing first {n} rows only — download the file to see everything.',
    unsupported: 'This format cannot be previewed in the browser. Open the original link or download it.',
  },
  entityCode: {
    detailTitle: '{name} details',
    detailTitleWithCode: '{name} details — {code}',
    types: {
      hoaDon: 'Invoice',
      traHang: 'Return',
      datHang: 'Order',
      phieuXuatKho: 'Goods issue',
      phieuNhapKho: 'Goods receipt',
      chuyenHang: 'Transfer',
      kiemKe: 'Stock take',
      yeuCauSuaChua: 'Repair request',
      yeuCauXuatHoaDon: 'E-invoice request',
      datHangNcc: 'Purchase order',
      phieuNhanHang: 'Receiving note',
      khachHang: 'Customer',
      product: 'Product',
    },
  },
}
